var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products-result-observer"},[_c(_vm.targetComponent,{tag:"component",attrs:{"result-data":_vm.resultData,"require-prof":_vm.requireProf,"standard-recommend-data":_vm.standardRecommendData,"csrf-token":_vm.csrfToken}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-393956f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Products/kurenotori/ProductsKurenotoriResult.vue
// module id = null
// module chunks = 